import UnitCountOne from "./../child/UnitCountOne";
import GeneratedContent from "./../child/GeneratedContent";
import GeneratedUserContent from "./../child/GeneratedUserContent";
import UserGrowthChart from "./../child/UserGrowthChart";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  handleUnauthorized,
  showConfirmationDialog,
} from "../../utils/apiHelper";
import Loader from "./../child/Loder";
import { getModulePermissions } from "../../utils/permissionUtils";

const DashBoardLayerOne = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [signupRange, setSignupRange] = useState("7"); // default 7 days

  const userPermissions = getModulePermissions("User");
  const compatibilityPermissions = getModulePermissions("Compatibility Control");
  const matchPermissions = getModulePermissions("Match Control");
  const effectiveCompatibilityPermissions = {
    ...compatibilityPermissions,
    canView: compatibilityPermissions.canView || matchPermissions.canView,
  };
  const vaultPermissions = getModulePermissions("vault-questions");

  useEffect(() => {
    fetchData();
  }, [signupRange]);

  const fetchData = async () => {
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/admin-dashboard?signupRange=${signupRange}`;
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINT, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const datas = await response.json();
      setItems(datas?.data || {});
    } catch (error) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };
  if (loading) return <Loader />;
  return (
    <>
      {/* UnitCountOne */}
      <UnitCountOne
        dashboardData={items}
        signupRange={signupRange}
        setSignupRange={setSignupRange}
         loading={loading} 
         setLoading={setLoading}
      />
      <section className="row gy-4 mt-1">
        <GeneratedUserContent
          dashboardData={{
            ...(userPermissions?.canView && {
              totalUsers: items.totalUsers,
              activeUsers: items.activeUsers,
              newSignUps: items.newSignUps,
              chartData: {
                users: items.chartData?.users,
                activeUsers: items.chartData?.activeUsers,
                newSignUps: items.chartData?.newSignUps,
              },
            }),
            ...(effectiveCompatibilityPermissions?.canView && {
              totalCompatibilities: items.totalCompatibilities,
              matchedCompatibilities: items.matchedCompatibilities,
              chartData: {
                ...(userPermissions?.canView
                  ? { ...items.chartData } // merge if userPermissions already added chartData
                  : {}),
                totalCompatibilities: items.chartData?.totalCompatibilities,
                matchedCompatibilities: items.chartData?.matchedCompatibilities,
              },
            }),
          }}
        />
      </section>
      <section className="row gy-4 mt-1">
        {vaultPermissions?.canView && (
          <GeneratedContent
            dashboardData={{
              totalVaultQuestions: items.totalVaultQuestions,
              // flaggedVaultQuestions: items.flaggedVaultQuestions,
              publishedVaultQuestions: items.publishedVaultQuestions,
              chartData: {
                totalVaultQuestions: items.chartData?.totalVaultQuestions,
                // flaggedVaultQuestions: items.chartData?.flaggedVaultQuestions,
                publishedVaultQuestions:
                  items.chartData?.publishedVaultQuestions,
                aiRevivedVaultQuestions:
                  items.chartData?.aiRevivedVaultQuestions,
              },
            }}
          />
        )}
      </section>

      {/* <section className="row gy-4 mt-1">
               <Calender />
            </section>  */}
    </>
  );
};

export default DashBoardLayerOne;
